import React from 'react'
import { useParams } from 'react-router-dom'

export default function Handoff(){
  const { id } = useParams()
  return (
    <div className="page">
      <h1>Handoff: {id}</h1>
      <p>Details and acknowledgment action here.</p>
    </div>
  )
}
